// src/com/download_info/DownloadPopup.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, CircularProgress } from '@mui/material';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';


const InfoTitle = styled(DialogTitle)({
    backgroundColor: '#007', // AppPalette.HeaderBackground,
    color: 'white',
    minWidth: 300,
});

const RecordBox = styled(Box)({
    display: 'flex', alignItems: 'center', padding: 5, marginTop: 10,
});

const TitleBox = styled(Box)({
    fontSize: '0.9rem', flexGrow: 1, // [이트레이스 사용매뉴얼]
});

const TypeBox = styled(Box)({
    fontSize: '0.8rem', color: '#555', marginLeft: 10, minWidth: 100, // [매뉴얼]
    textAlign: 'center',
});

const DateBox = styled(Box)({
    fontSize: '0.8rem', color: '#555', marginLeft: 10
});

/*
{
    "msg":"ok",
    "list":[
        {"type":"매뉴얼", "title":"이트레이스 사용매뉴얼", "url":"/files/pub/abc.txt", "date":"2015-07-22"},
        {"type":"신청서", "title":"구비서류_은행(자동이체)신청서", "url":"/files/pub/xyz.txt", "date":"2019-08-08"}
    ]
}
*/

export default function DownloadPopup({
    open,
    onClose,
}) {
    const [fileList, setFileList] = useState([]);
    // 로딩 및 에러 상태 관리를 위한 state
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    // use fetch to get json file (static)

    // 컴포넌트가 처음 렌더링될 때 데이터를 불러옵니다.
    useEffect(() => {
        if(open) {
            fetch('/files/cvoFiles.json') // public 폴더의 파일은 루트 경로로 접근
                .then(response => {
                    if (!response.ok) {
                        throw new Error('데이터를 불러오는 데 실패했습니다.');
                    }
                    return response.json();
                })
                .then(data => {
                    // 데이터 형식이 올바른지 확인 후 state 업데이트
                    if (data.msg === 'ok' && Array.isArray(data.list)) {
                        setFileList(data.list);
                    } else {
                        throw new Error('데이터 형식이 올바르지 않습니다.');
                    }
                })
                .catch(err => {
                    console.error("파일 목록 fetch 오류:", err);
                    setError(err.message);
                })
                .finally(() => {
                    setLoading(false); // 로딩 종료
                });
        }
        else {
            setFileList([]);
        }
    }, [open]);

    const renderList = () => {
        return(
            <Box>
                {fileList.map((file, index) => {
                    const idxLastSlash = file.url.lastIndexOf('/');
                    const path = file.url.substring(0, idxLastSlash + 1);
                    const filePart = file.url.substring(idxLastSlash + 1);
                    const url = path + encodeURIComponent(filePart);
                    return(
                        <RecordBox key={index}>
                            <DownloadForOfflineIcon fontSize="small" style={{ marginRight: 5 }} />
                            <TitleBox>
                                <a href={url} target="_blank" rel="noopener noreferrer" download>
                                    {file.title}
                                </a>
                            </TitleBox>
                            <TypeBox>{file.type}</TypeBox>
                            <DateBox>{file.date}</DateBox>
                        </RecordBox>)
                    ;
                })}
            </Box>
        );
    };
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md">
            <InfoTitle>
                파일 다운로드
            </InfoTitle>
            <DialogContent>
                {
                    loading
                    ?
                    <CircularProgress size={24} />
                    :
                    error
                    ?
                    <Box style={{margin: 30, color: '#f44336'}}>
                        {error}
                    </Box>
                    :
                    renderList()
                }
            </DialogContent>
        </Dialog>
    );
}
